// extracted by mini-css-extract-plugin
module.exports = {"bq-text":"_2pTyX","quote-with-icon":"_2ub65","bq-attribution":"iAbpQ","quote-wrapper":"_1sYFa"};